import { useEffect, useState } from 'react'
import {
  browserName,
  isAndroid as isAndroidReactDeviceDetect,
  isIOS as isIOSReactDeviceDetect,
} from 'react-device-detect'

/**
 * Hook for client OS detection. Resolution of the device OS is done on client side to prevent HTML mismatch ('react-device-detect' is only available on client)
 */
export const useDeviceOSDetect = () => {
  const [isDetermined, setIsDetermined] = useState(false)
  const [isIOS, setIsIOS] = useState(false)
  const [isAndroid, setIsAndroid] = useState(false)
  const [isInstagram, setIsInstagram] = useState(false)

  useEffect(() => {
    setIsIOS(isIOSReactDeviceDetect)
    setIsAndroid(isAndroidReactDeviceDetect)
    setIsInstagram(browserName.toLowerCase() === 'instagram')
    setIsDetermined(true)
  }, [])

  return {
    isIOS,
    isAndroid,
    isInstagram,
    isDetermined,
  }
}
